import { useCallback, useState } from 'react';

import ErrorInfo from 'components/ErrorInfo/ErrorInfo';
import { Input } from '@trackman/web-shared-components';
import { httpsUrlValidator } from 'utilities/urlValidators';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

export const URLInput = observer(() => {
  const es = useStores().trackmanEventsEditorStore;
  const [error, setError] = useState(false);

  const handleOnChange = useCallback(
    (newValue: string) => {
      const isError = !httpsUrlValidator(newValue);
      setError(isError);
      es.eventItem.meetingUrl = newValue;
    },
    [es.eventItem, setError]
  );

  return (
    <div className='admin-edit-section'>
      <h2>{es.eventItem.locationType === 'Online' && 'Teams'} URL*</h2>
      <div className='input-wrapper'>
        <Input
          label='URL'
          value={es.eventItem.meetingUrl ?? ''}
          required
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(e.currentTarget.value)}
          hint={error ? <ErrorInfo errorMsg='Please enter a valid URL starting with https://' /> : ' '}
          error={error}
        />
      </div>
    </div>
  );
});

export default URLInput;
